import React from 'react';
import clsx from 'clsx'

import { IMainLoaderProps } from './MainLoaderProps'
import PageHeader from '../../components/atoms/PageHeader/PageHeader'
import { HEADER_LEVEL } from '../../components/atoms/PageHeader/PageHeaderProps'
import Paragraph from '../../components/atoms/Paragraph/Paragraph'
import { APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'

import './MainLoader.scss'

/**
 * Komponent Loadera
 * Projekt oraz style zaczerpnięte ze strony: https://loading.io/css/
 * 
 * !!! Nie należy zmieniać ilości znaczników <div /> gdyż spowoduje to rozjechanie się loadera!!
 * @returns 
 */
const MainLoader = (props: IMainLoaderProps) => {

   return (
		<div className={clsx("loading-screen", props.additionalClassName)}>
			<div className='main-loader-wrapper'>
				<div /> 	<div />  <div />  <div />
				<div />  <div />  <div /> 	<div /> 
				<div />  <div />	<div />  <div />
			</div>
			{
				Boolean(props.headingText !== undefined) && (<PageHeader title={props.headingText ?? ''} level={HEADER_LEVEL.H1} align='center' className='loading-heading-text' /> )
			}
			{
				Boolean(props.descriptionText !== undefined) && (<Paragraph  size={APP_FONT_SIZE.MEDIUM} align='center' >{ props.descriptionText }</Paragraph> )
			}
		</div>
	)
}

export default MainLoader
